<div  #refElement class="container-fluid stdTheme" *ngIf="okToDisplayMenu"
        [ngStyle]="{margin: '0px', 'margin-top': '0px', width: '100%', padding: '0px'}" >
    <mat-card class="register-card stdTheme wkscard" layout="column" flex 
        style="padding: 0px; padding-right: 5px; padding-left: 5px; height: 100%;padding-bottom: 10px;overflow-x: hidden!important; overflow-y: hidden!important;"
        >
        <mat-card-title style="text-align: center;" >
            <div class="flex-row row" style="margin: 0px; padding: 0px;">
                <div class="col-lg-12 col-xs-12  " style="display: flex;justify-content: center;">
                    {{ 'SUPPLIERS_ORDERS.TITLE' | translate }}  
                </div>
            </div>
            <div class="flex-row row" style="margin: 0px; padding: 0px;">
                <div class="col-lg-12 col-xs-12" style="display: flex;justify-content: center;">
                    <mat-select id="warehouse" #warehouse panelClass="mdiselectcontent" ngDefaultControl
                        [(value)]="warehouseCur" class="warehousePanel"
                        (selectionChange)="warehouseChoice(warehouse.value)">
                        <mat-option class="selectOptionsTheme" *ngFor="let warehouseCur of wareHousesList"
                            [value]="warehouseCur.warehouseId"> {{warehouseCur.warehouseRef}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </mat-card-title> 
        <mat-card-actions style="flex-direction: row;box-sizing: border-box;display: flex;margin-left: 0px;margin-right: 0px;" >
           
            <button [disabled]="!btnQuit" mat-raised-button (click)="logout()" title="{{ 'COMMUN.BUTTON.LOGOUT' | translate }}">
                <!--<i class="fas fa-sign-out" aria-hidden="true" style="font-size: 15px"></i>-->
                <mat-icon>exit_to_app</mat-icon>
            </button>
        </mat-card-actions>
    </mat-card>
</div>

